import React from "react";
import { InfoIcon } from "../../../../svg/info-icon";

interface BadgeCellProps {
  value: {
    text: string;
    color?: string;
    bgColor?: string;
    displayText?: string;
    showInfoIcon?: boolean;
    hoverText?: string;
  };
  [key: string]: any;
}

export const BadgeCell: React.FC<BadgeCellProps> = ({ value }) => {
  return (
    <div className="flex w-full flex-row items-center gap-1">
      <div
        className="table-cell-badge"
        style={{
          color: value.color || "#000000",
          backgroundColor: value.bgColor || "#F5F5F5",
        }}
        title={value.displayText}
      >
        {value.text}
      </div>
      {value.showInfoIcon && (
        <div title={value.hoverText} className="cursor-pointer">
          <InfoIcon />
        </div>
      )}
    </div>
  );
};

export default BadgeCell;
